import React from 'react';
import {
  ActionBanner, FilledButton, FlexRow, SvgIcon
} from '@make-software/tg-mini-app-ui';

import { BannerSection, PageWrapper, TitleRow } from '@/shared';
import { EARN_PATH, HOLIDAY_GIVEAWAY } from '@/app/paths';
import InfoIcon from '@/shared/assets/icons/ic-info.svg';
import { useScreen } from '@/pages/home/useScreen';
import { openLink } from '@/utils';
import { HOW_VOTING_WORKS_URL } from '@/constants';
import { HackathonProjectList } from '@/pages/home/home.styled';
import { SortOption } from '@/entities';

import { EarnSection, EmptyProjects, HackathonHeader, ProjectsList } from './components';

export const Home: React.FC = () => {
  const {
    projects,
    loading,
    error,
    navigateToFantomRun,
    navigateToProject,
    canLoadMore,
    loadMore,
    filters,
    handleSort,
    roundVoteRanking,
    navigateTo
  } = useScreen();

  // const navigate = useNavigate();
  // const { collect } = useCollect();
  //
  // const { tasks, handleSelectTask } = useMakeTrafficManager();
  // const seasonInfo = useSelector(selectSeasonInfoData);
  // const userRank = useSelector(selectUserRank);
  //
  // const rankPosition = userRank?.position ?? '-';
  //
  // const homeTasks = React.useMemo(() => {
  //   const available = tasks.filter((t) => !t.userState.isRewarded);
  //   const platformFiltered = filterTasksByPlatform(available);
  //   return platformFiltered.slice(0, MAX_HOME_TASKS);
  // }, [tasks]);
  //
  // const isSeasonEnded = React.useCallback(() => {
  //   const currentDate = new Date();
  //   return currentDate > SEASON_ENDS_ON;
  // }, []);
  //
  // useOnMountUnsafe(async () => {
  //   await collect({ url: HOME_PATH });
  // });
  //
  // const handleEarnRedirect = React.useCallback(() => {
  //   navigate(EARN_PATH);
  // }, [navigate]);
  //
  // const handleDropRedirect = React.useCallback(() => {
  //   navigate(DROP_PATH);
  // }, [navigate]);
  //
  // const handleCalendarRedirect = React.useCallback(() => {
  //   // navigate(GAMES_PATH);
  // }, []);

  return (
    <>
      <PageWrapper>
        <BannerSection />
      </PageWrapper>

      <PageWrapper>
        {/*<ActionBanner*/}
        {/*  title="Get"*/}
        {/*  subtitle="for invited friend"*/}
        {/*  reward={250}*/}
        {/*  iconSrc={GoldIcon}*/}
        {/*  iconColor="#F1BF0B"*/}
        {/*  buttonText="Invite"*/}
        {/*  onClick={onInviteBannerPress}*/}
        {/*  background="linear-gradient(90deg, #8A4D50 0%, #212228 100%)"*/}
        {/*  titleProps={{ monotype: false, fontWeight: '600', fontFamily: 'JetBrains Mono' }}*/}
        {/*  subtitleProps={{*/}
        {/*    monotype: false,*/}
        {/*    fontSize: '14px',*/}
        {/*    fontWeight: '400',*/}
        {/*    fontFamily: 'Inter',*/}
        {/*    style: { opacity: 0.8 }*/}
        {/*  }}*/}
        {/*  rewardProps={{*/}
        {/*    monotype: true,*/}
        {/*    fontWeight: '600',*/}
        {/*    fontFamily: 'JetBrains Mono, monotype'*/}
        {/*  }}*/}
        {/*  buttonProps={{ fontSize: '12px', fontFamily: 'Inter', fontWeight: 500 }}*/}
        {/*/>*/}
        <ActionBanner
          title="Get your free fans.cspr subname"
          buttonText="Claim"
          onClick={navigateTo(HOLIDAY_GIVEAWAY)}
          background="linear-gradient(90deg, #8A4D50 0%, #212228 100%)"
          titleProps={{ monotype: false, fontWeight: '600', fontFamily: 'Inter' }}
          subtitleProps={{
            monotype: false,
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'Inter',
            style: { opacity: 0.8 }
          }}
          buttonProps={{ fontSize: '12px', fontFamily: 'Inter', fontWeight: 500 }}
        />
        <EarnSection
          onChallengesClick={navigateTo(EARN_PATH)}
          onFantomRunClick={navigateToFantomRun}
        />
      </PageWrapper>


      <HackathonProjectList>
        <FlexRow align="center" gap={10}>
          <TitleRow
            weight={1}
            size="lg"
            color="#FFFFFF"
            margin="0"
            fontWeight={700}
            fontFamily="Inter">
            CSPR.fans - The Agentic Buildathon
          </TitleRow>
          <SvgIcon
            src={InfoIcon}
            size={24}
            color="#A9AAAD"
            style={{ cursor: 'pointer' }}
            onClick={openLink(HOW_VOTING_WORKS_URL)}
          />
        </FlexRow>

        {projects?.length ? (
          <>
            <HackathonHeader
              filerItems={filters}
              onSelect={(label: SortOption) => handleSort(label)}
            />
            <ProjectsList
              projects={projects}
              loading={loading}
              error={error}
              onProjectClick={navigateToProject}
              voteRanking={roundVoteRanking}
            />
          </>
        ) : (
          <EmptyProjects />
        )}

        {canLoadMore && (
          <FilledButton
            title={loading ? 'Loading…' : 'Load more'}
            disabled={loading}
            onClick={loadMore}
          />
        )}
      </HackathonProjectList>
    </>
  );
};
